import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function LabMenu() {
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-3 col-lg-4 col-md-6 mb-4">

            <Link to={link} className="menu-link">

                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>

                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>

                    <p className="menu-title">{title}</p>

                </div>

            </Link>

        </div>
    );
    return (
        <section className="container-fluid mt-4">

            <h5 className="menu-section-title">Lab Master Setting</h5>

            <div className="row">

                <MenuCard link="/add-cat" title="Add Lab Category" icon="fa-solid fa-folder-plus" color="#0d6efd"/>

                <MenuCard link="/add-subcat" title="Add Lab Sub Category" icon="fa-solid fa-folder-tree"
                          color="#20c997"/>

                <MenuCard link="/add-test" title="Add Lab Component" icon="fa-solid fa-vial" color="#6f42c1"/>

                <MenuCard link="/view-test" title="View Categories" icon="fa-solid fa-list" color="#fd7e14"/>

            </div>

            <h5 className="menu-section-title">Lab Technician</h5>

            <div className="row">

                <MenuCard link="/order-accept" title="Order Accept" icon="fa-solid fa-check" color="#0d6efd"/>

                <MenuCard link="/sample-collect" title="Sample Collect" icon="fa-solid fa-syringe" color="#20c997"/>

                <MenuCard link="/lab-view" title="Lab Entry" icon="fa-solid fa-flask" color="#6f42c1"/>

                <MenuCard link="/lab-result-view" title="View Lab Report" icon="fa-solid fa-file-medical"
                          color="#fd7e14"/>

                <MenuCard link="/lab-result-view-all" title="All Lab Reports" icon="fa-solid fa-folder-open"
                          color="#dc3545"/>

            </div>

            <h5 className="menu-section-title">Lab Reports</h5>

            <div className="row">

                <MenuCard link="/collection-lab" title="Collection Report" icon="fa-solid fa-chart-line"
                          color="#198754"/>

            </div>

        </section>
    )
}
export default LabMenu;